'use client';

import rte from '@/utils/rte';

// BL-651: heading_label and description already render outside the modal
// (heading_label as the trigger link, description as visible copy below the
// buttons) — showing them again in here duplicated that content, which is
// what the review flagged. The modal is just the deeper RTE body.
const V2ExtendedOptionButtonsModal = ({ pitstop }) => {
  const { additional_content } = pitstop ?? {};
  const html = rte(additional_content);
  if (!html) return null;

  return (
    <div
      className="rte-content rte-content--light px-6 py-10 sm:px-8 sm:py-12 lg:px-10 lg:py-8 text-center font-worksans text-base leading-relaxed text-primary [&_h3]:[font-family:var(--font-cormorant)] [&_h3]:font-normal [&_h3]:text-2xl [&_h3]:mb-4 [&_p]:mb-4 [&_p:last-child]:mb-0"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default V2ExtendedOptionButtonsModal;
